import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_navbar/')({
  beforeLoad: () => {
    throw redirect({ to: '/experiments' });
  },
});
